export class FamilyOptionModel implements IFamilyOptionModel {
    option: OptionModel | null = null;
    displayOrder: number = 0;
    optionGroup: string = '';
    defaultValue: FilterOptionSelectedValueModel | null = null;
}

export interface IFamilyOptionModel {
    option: OptionModel | null;
    displayOrder: number;
    optionGroup: string;
    defaultValue: FilterOptionSelectedValueModel | null;
}

export class OptionModel implements IOptionModel {
    code: string = '';
    type: string = '';
    name: string = '';
    values: FilterOptionValueModel[] = [];
    facets: FilterOptionFacetModel[] = [];
}

export interface IOptionModel {
    code: string;
    type: string;
    name: string;
    values: FilterOptionValueModel[];
    facets: FilterOptionFacetModel[];
}

export interface FilterOptionFacetModel {
    code: string;
    values: FilterOptionFacetValueModel;
    aggregationValues: FilterOptionFacetAggregationValues;
}

export interface FilterOptionFacetAggregationValues {
    Min: number;
    Max: number;
    Average: number;
    Sum: number;
}

export interface FilterOptionFacetValueModel {
    [name: string]: number
}

export interface FilterOptionValueModel {
    code: string;
    name: string;
}

export class FilterOptionSelectedValueModel {
    codes: string[] = [];
    text: string | null = null;
    minValue: number | null = null;
    maxValue: number | null = null;
    boolValue: boolean | null = null;

    public hasValue(): boolean {
        return this.codes.length > 0 || !!this.minValue || !!this.maxValue || !!this.text || (this.boolValue || false);
    }

    public clearValue(): void {
        this.codes = [];
        this.text = null;
        this.minValue = null;
        this.maxValue = null;
        this.boolValue = false;
    }
}
